import { CardHistoryTabs } from "@/modules/card/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";

export const getCardHistoryTabItems = ({ t }: ITabItemsProps) => [
  {
    value: CardHistoryTabs.Transactions,
    label: t("cards.historyTable.transactions"),
    dataId: "transaction-tab",
    disabled: false,
  },
  {
    value: CardHistoryTabs.OnlineTransactions,
    label: t("cards.historyTable.onlineTransactions"),
    dataId: "online-transaction-tab",
    disabled: false,
  }];
